import { motion } from 'framer-motion';
import CtaButton from '@/components/CtaButton';
import SmartLink from '@/components/SmartLink';
import SEO from '@/components/SEO';
import { content } from '@/content/content';

const NotFound = (): JSX.Element => {
  const { notFound, seo } = content;

  return (
    <>
      <SEO title={seo.notFound.title} description={seo.notFound.description} keywords={seo.notFound.keywords} />
      <motion.section
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        aria-labelledby="notfound-heading"
        className="mx-auto max-w-2xl py-12 sm:py-20"
      >
        <span className="eyebrow">Error · HTTP {notFound.title}</span>
        <h1
          id="notfound-heading"
          className="mt-3 font-display text-[clamp(4.5rem,20vw,9rem)] font-extrabold leading-none tracking-nameplate text-[color:var(--fg)]"
        >
          {notFound.title}
        </h1>
        <h2 className="mt-2 font-display text-2xl font-bold text-[color:var(--fg)] sm:text-3xl">
          {notFound.subtitle}
        </h2>
        <p className="mt-4 max-w-xl text-lg leading-relaxed text-[color:var(--fg-muted)]">{notFound.body}</p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <CtaButton to={notFound.ctaHome.to} variant="solid">
            {notFound.ctaHome.label}
          </CtaButton>
          <CtaButton to={notFound.ctaContact.to} variant="ghost">
            {notFound.ctaContact.label}
          </CtaButton>
        </div>

        <div className="mt-12 border-t border-[color:var(--hairline)] pt-6">
          <p className="eyebrow mb-3">{notFound.popularHeading}</p>
          <ul className="space-y-2.5">
            {notFound.popularLinks.map(({ to, label }) => (
              <li key={to}>
                <SmartLink
                  to={to}
                  className="group inline-flex items-center gap-2 rounded font-mono text-sm text-[color:var(--fg-muted)] transition-colors hover:text-primary-ink dark:hover:text-primary"
                >
                  <span aria-hidden="true" className="text-primary-ink transition-transform group-hover:translate-x-0.5 dark:text-primary">
                    ▸
                  </span>
                  {label}
                </SmartLink>
              </li>
            ))}
          </ul>
        </div>
      </motion.section>
    </>
  );
};

export default NotFound;
